<script setup lang="ts">
import { legalSteps, ClaimLegalStepName } from '@/utils/config/constants/claims-legal-steps';
import { computed } from 'vue';
import DotLegalStep from './DotLegalStep.vue';

const props = defineProps({
  name: {
    required: true,
    type: String as () => ClaimLegalStepName // cast it
  },
  additionalText: {
    required: false,
    type: String,
  },
  rounded: {
    default: "rounded-full",
    type: String as () => "rounded-full" | "rounded-sm" | "rounded-md" | "rounded-lg"
  },
  dot: {
    required: false,
    type: Boolean
  },
});

const legalStepColor = computed(() => legalSteps[props.name].color);
</script>
<template>
  <!-- Legacy badge -->
  <span v-if="false" class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
    <svg :class="`h-1.5 w-1.5 fill-${legalStepColor}-500`" viewBox="0 0 6 6" aria-hidden="true">
      <circle cx="3" cy="3" r="3" />
    </svg>
    {{ legalSteps[name].displayText }}{{ additionalText }}
  </span>
  <span v-if="dot" class="inline-flex items-center gap-x-1.5 rounded-full py-1 text-xs font-medium text-gray-900">
    <!-- <div :class="`flex-none p-1 rounded-full text-${legalStepColor}-400 bg-${legalStepColor}-400/10`">
      <div :class="`h-1.5 w-1.5 rounded-full bg-${legalStepColor}-600`"></div>
    </div> -->
    <DotLegalStep :legalStepName="name" />
    {{ legalSteps[name].displayText }}{{ additionalText }}
  </span>
  <span
    v-else
    class="inline-flex items-center px-2.5 py-0.5 border ring-inset rounded-md text-xs font-medium capitalize"
    :class="`${rounded} bg-${legalStepColor}-50 text-${legalStepColor}-700 border-${legalStepColor}-600/10`"
  >
    {{ legalSteps[name].displayText }}{{ additionalText }}
  </span>
</template>